import React, { useState, useEffect } from "react";
import { withNamespaces } from "react-i18next";
import { Form, Col, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import "~/assets/css/icons.css";
import "../OnboardingMainPage.css";

import Spinner from "~/components/Spinner";

import { persistAPISettings } from "~/store/ducks/onboardingSettings/actionTypes";

const Config = ({ t }) => {
  const dispatch = useDispatch();

  const { isLoadingPersistApiSettings, isLoadingGetApiSettings, apiSettings } =
  useSelector((state) => state.onboardingSettingsReducer);

  const { user } = useSelector((state) => state.globalReducer);

  useEffect(() => {
    if (Object.keys(apiSettings).length !== 0) {
      apiSettings.sso?.endpoint && setEndpoint(apiSettings.sso.endpoint);
    }
  }, [apiSettings]);

  const [endpoint, setEndpoint] = useState("");
  const [validated, setValidated] = useState(false);

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidated(true);
    } else {
      saveSsoConfig();
    }
  };

  const saveSsoConfig = () => {
    const organizationId = user.organization?.id;
    let payload = apiSettings;
    if (organizationId) {
      if (!apiSettings.organizationId) {
        payload.organizationId = organizationId;
      }
      payload.sso = { endpoint };
      dispatch(persistAPISettings(payload));
    }
  };

  return (
    <>
      <div className="onboarding-test-form">
        <Form
          noValidate
          validated={validated}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
            }
          }}
          encType="multipart/form-data"
          onSubmit={(e) => {
            handleSubmit(e);
          }}
        >
          <h3 className="onboarding-form-header">
            {t("onboarding.general.config")}
          </h3>
          <Form.Row>
            <Col sm="12" md="8" lg="8">
              <Form.Group controlId="validationSSOEndpoint">
                <Form.Label>Token</Form.Label>
                <Form.Control
                  type="text"
                  autofill="false"
                  required
                  value={endpoint}
                  onChange={(e) => setEndpoint(e.target.value)}
                />
                <Form.Control.Feedback type="invalid">
                  {t("onboarding.persist.requiredEndpoint")}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Form.Row>
          <Button
            disabled={!user?.organization?.id}
            type="submit"
            className="card-button onboarding-button"
          >
            {isLoadingPersistApiSettings || isLoadingGetApiSettings ? (
              <>
                {t("onboarding.general.loading")}
                <Spinner
                  as="span"
                  animation="grow"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              </>
            ) : (
              t("onboarding.general.save")
            )}
          </Button>
        </Form>
      </div>
    </>
  );
};
export default withNamespaces()(Config);
